import { Component } from '@angular/core';

@Component({
  selector: 'app-customer-details-error.dialog',
  templateUrl: './customer-details-error.dialog.component.html',
  styleUrl: './customer-details-error.dialog.component.scss'
})
export class CustomerDetailsErrorDialogComponent {

}
